import styled from 'styled-components/macro';
import { FieldContainer } from '../../../shared/form/FormField';
import { Header1, Header2, Header3, Header4, Header5 } from '../../../shared/Headers';
import { spacing04 } from '../../../styling/spacing';

export const SectionHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  margin-bottom: ${spacing04};
  
  ${Header1}, ${Header2}, ${Header3}, ${Header4}, ${Header5} {
    margin: 0;
  }
  
  ${FieldContainer} {
    margin: 0;
  }
`;
